import { ReactNode } from 'react';
import './Button.css';

export type ButtonOnClickHandler = () => void;

export type ButtonSizing = 'sm' | 'md' | 'lg';

export interface ButtonProps {
    children?: ReactNode;
    className?: string;
    onClick: ButtonOnClickHandler;
    size?: ButtonSizing;
}

export default function Button({ children, className, onClick, size = 'md' }: ButtonProps) {
    return (
        <button className={`custom-button ${className ?? ''} ${size}`.trim()} onClick={onClick}>
            <div>{children}</div>
        </button>
    );
}
